import React from "react";
import { Eye } from "lucide-react";
import { useProductViews, formatViews } from "../../hooks/useProductViews";

/** Overlay "👁 n" (product page views). Renders nothing if the article has no views. */
export const ViewsBadge = ({ articleId, className = "bottom-2 right-2" }) => {
  const viewsMap = useProductViews();
  const views = viewsMap[articleId] || 0;
  if (!views) return null;
  return (
    <span
      className={`absolute z-10 inline-flex items-center gap-1 bg-black/70 backdrop-blur text-gray-200 text-[11px] font-semibold px-2 py-0.5 rounded-full ${className}`}
      title={`${views} visualizzazioni`}
      data-testid={`product-views-${articleId}`}
    >
      <Eye className="w-3 h-3" /> {formatViews(views)}
    </span>
  );
};
